import React, { useEffect, useRef, useState } from 'react';
import { motion } from 'framer-motion';
import { useLocation } from 'react-router-dom';
import { collection, getDocs } from 'firebase/firestore';
import { db } from '../Config/Config';
import noImage from '../assets/no-photos-icon-vector-image-can-be-used-spa_120816-264914.png';
const fadeUp = {
  hidden: { opacity: 0, y: 16 },
  visible: { opacity: 1, y: 0, transition: { duration: 0.5 } },
};
const stagger = {
  hidden: {},
  visible: { transition: { staggerChildren: 0.1 } },
};

const Gallery = () => {
  const scrollerRef = useRef(null);
  const scrollByAmount = (delta) => scrollerRef.current?.scrollBy({ left: delta, behavior: 'smooth' });
  const { pathname } = useLocation();
  const isStandalone = pathname === '/gallery';
  const sectionProps = isStandalone
    ? { variants: stagger, initial: 'hidden', animate: 'visible' }
    : { variants: stagger, initial: 'hidden', whileInView: 'visible', viewport: { once: true, amount: 0.1 } };
const [gallery, setGallery] = useState([]);

      useEffect(() => {
        fetchGalleryData();
      }, []);
     
    const fetchGalleryData = async () => {
        const ref = collection(db, "website-management", "gallery", "data");
        const snap = await getDocs(ref);
  
        const arr = snap.docs.map(doc => ({
          id: doc.id,
          ...doc.data()
        }));
  
        setGallery(arr);
      }
  return (
    <motion.section className="py-10" {...sectionProps}>
      {/* Title pill */}
      <div className="flex justify-start mb-8 max-w-7xl mx-auto px-4">
        <motion.div variants={fadeUp} className="px-0 py-2  text-brand-primary/90   text-xl md:text-xl font-medium">
          G<span className="text-black">allery</span>
        </motion.div>
      </div>

      {/* Horizontal scroller */}
      <motion.div variants={fadeUp} className="relative max-w-7xl mx-auto px-4">
        <div className="relative" >
          <div className="pointer-events-none absolute inset-y-0 left-0 w-10  from-white/70 to-transparent" />
          <div className="pointer-events-none absolute inset-y-0 right-10 w-10 bg-gradient-to-l from-white/70 to-transparent" />
          <motion.div ref={scrollerRef} className="flex gap-6 overflow-x-auto no-scrollbar pr-14 snap-x snap-mandatory" variants={stagger}>
            {gallery.map((_, i) => (
              <motion.div key={i} variants={fadeUp} className="min-w-[400px] sm:min-w-[400px]  snap-start  overflow-hidden shadow-soft bg-white">
                <div className="relative h-[400px] bg-slate-100">
                  <img
                    alt="gallery"
                    className={`w-full h-[400px] object-cover`}
                    src={gallery[i].image || noImage}
                  />
                  <span className="absolute top-2 right-2 text-black text-sm font-medium bg-white/80 px-2 py-0.5 rounded">Image</span>
                </div>
                <div className="bg-indigo-500 text-white text-center py-4">
                  <div className="font-semibold">{gallery[i].description}</div>
                  <div className="text-sm opacity-90">{gallery[i].story}</div>
                </div>
              </motion.div>
            ))}
          </motion.div>
          {/* Arrows */}
          <div className="absolute inset-y-0 right-0 flex items-center pr-2">
            <button
              aria-label="Scroll left"
              onClick={() => scrollByAmount(-320)}
              className="hidden sm:grid w-10 h-10 place-content-center text-3xl leading-none text-brand-primary mr-1"
            >
              <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="lucide lucide-circle-chevron-left-icon lucide-circle-chevron-left"><circle cx="12" cy="12" r="10"/><path d="m14 16-4-4 4-4"/></svg>
            </button>
            <button
              aria-label="Scroll right"
              onClick={() => scrollByAmount(320)}
              className="grid w-10 h-10 place-content-center text-3xl leading-none text-brand-primary"
            >
              <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="lucide lucide-circle-chevron-right-icon lucide-circle-chevron-right"><circle cx="12" cy="12" r="10"/><path d="m10 16 4-4-4-4"/></svg>
            </button>
          </div>
        </div>
      </motion.div>
    </motion.section>
  );
};

export default Gallery;
